import React from 'react';
import './PixelSpinner.css';

const PixelSpinner = ({ size = 64, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    className={`pixel-spinner ${className}`}
  >
    {/* 8 squares in a circle, animated sequentially to preserve axis-aligned pixel grid */}
    {/* Top: Large hollow */}
    <rect className="pixel-block" style={{ animationDelay: '0s' }} x="40" y="5" width="20" height="20" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="4" />
    {/* Top-Right: Large hollow */}
    <rect className="pixel-block" style={{ animationDelay: '0.1s' }} x="70" y="15" width="20" height="20" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="4" />
    {/* Right: Medium hollow */}
    <rect className="pixel-block" style={{ animationDelay: '0.2s' }} x="82" y="42" width="14" height="14" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="3" />
    {/* Bottom-Right: Small hollow */}
    <rect className="pixel-block" style={{ animationDelay: '0.3s' }} x="72" y="72" width="10" height="10" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="2" />
    {/* Bottom: Medium solid */}
    <rect className="pixel-block" style={{ animationDelay: '0.4s' }} x="42" y="82" width="16" height="16" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="3" />
    {/* Bottom-Left: Large solid */}
    <rect className="pixel-block" style={{ animationDelay: '0.5s' }} x="15" y="70" width="20" height="20" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="4" />
    {/* Left: Small solid */}
    <rect className="pixel-block" style={{ animationDelay: '0.6s' }} x="5" y="45" width="10" height="10" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="2" />
    {/* Top-Left: Tiny solid */}
    <rect className="pixel-block" style={{ animationDelay: '0.7s' }} x="20" y="20" width="6" height="6" fill="var(--scan-coral, #f1563f)" stroke="var(--scan-text, #121417)" strokeWidth="2" />
  </svg>
);

export default PixelSpinner;
